"use client"

import AddIcon from "@mui/icons-material/Add"
import CloseIcon from "@mui/icons-material/Close"
import DownloadIcon from "@mui/icons-material/Download"
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography
} from "@mui/material"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import dayjs from 'dayjs'
import 'dayjs/locale/it'
import React, { useEffect, useState } from "react"
import toast from 'react-hot-toast'
import { useNavigate, useParams } from "react-router-dom"
import { AuthContext } from "../../context"
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar"
import apiService from "../../services/api-service"

let filesContent

const GarbageFirstCopyAdd = () => {
  const authContext = React.useContext(AuthContext)
  const navigate = useNavigate()
  const { id } = useParams()
  const [activeStep, setActiveStep] = useState(0)
  const [formData, setFormData] = useState({
    supplier: "",
    cer_code: "",
    date: dayjs(new Date()).format("YYYY-MM-DD"),
    file: null,
    url: null,
    wastes: [],
  })
  const [fieldErrors, setFieldErrors] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (id) {
      apiService
        .get(
          "/garbage-first-copy/",
          { id: id },
          {},
        )
        .then((response) => {
          if (response) {
            setFormData(response)
          }
        })
        .catch((error) => {
          handleSetNotification("Errore durante la chiamata al server, codice d'errore #08514262429906", "error")
        })
    }
  }, [id])

  const handleSetNotification = (msg, severityType) => {
    if (severityType === 'success') {
      toast.success(msg, {id: 'garbage-first-copy-add-toast'});
    } else {
      toast.error(msg, {id: 'garbage-first-copy-add-toast'});
    }
  }

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }))
    setFieldErrors((prevErrors) => ({ ...prevErrors, [name]: false }))
  }

  const handleAddWaste = () => {
    setFormData((prevData) => ({
      ...prevData,
      wastes: [...prevData.wastes, { material: "", quantity: "" }],
    }))
  }

  const handleWasteInputChange = (index, field, value) => {
    const newWastes = [...formData.wastes]
    newWastes[index] = { ...newWastes[index], [field]: value }
    setFormData((prevData) => ({ ...prevData, wastes: newWastes }))
  }

  const validateStep = (step) => {
    const errors = {}
    if (step === 0) {
      if (!formData.supplier) errors.supplier = true
      if (!formData.cer_code) errors.cer_code = true
      if (!formData.date) errors.date = true
      if (!formData.file && !formData.url) errors.file = true
    } else if (step === 1) {
      if (formData.wastes.length === 0) {
        handleSetNotification("Aggiungi almeno un rifiuto", "error")
        return false
      }

      formData.wastes.forEach((waste, index) => {
        if (!waste.material) errors[`waste_${index}_material`] = true
        if (!waste.quantity) errors[`waste_${index}_quantity`] = true
      })
    }
    setFieldErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((prevStep) => prevStep + 1)
    } else {
      handleSetNotification(`Compila tutti i campi prima di procedere`, "error")
    }
  }

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1)
  }

  const handleSubmit = async () => {
    if (validateStep(1)) {
      setLoading(true)
      try {
        let data = null
        if (formData.file) {
          formData.file.content = filesContent

        }
        if ( id ) {
          data = {document: formData, id: id, area_id : localStorage.getItem("areaSelected")}
        }
        else {
          data = {document: formData, area_id : localStorage.getItem("areaSelected")}
        }

        await apiService.post(
          "/garbage-first-copy/",
          {},
          data,
        )
        handleSetNotification("Registrazione creata con successo", "success")
        navigate("/garbage-first-copy-managment/")
      } catch (error) {
        handleSetNotification("Errore durante la chiamata al server, codice d'errore #08514262429906", "error")
      } finally {
        setLoading(false)
      }
    } else {
      handleSetNotification(`Compila tutti i campi prima di procedere`, "error")
    }
  }

  const handleFileChange = (event) => {
    if (!event.target.files) return

    const filePromise = new Promise((resolve) => {
      const reader = new FileReader()
      reader.onloadend = () => {
        const fileObj = {
          name: event.target.files[0].name,
          type: event.target.files[0].type,
          size: event.target.files[0].size,
          modified: event.target.files[0].lastModified,
          content: null,
        }
        const contentObj = reader.result

        filesContent = contentObj

        resolve(fileObj)
      }
      reader.readAsDataURL(event.target.files[0])
    })

    Promise.resolve(filePromise).then((processedFile) => {
      setFormData((prevDoc) => ({ ...prevDoc, file: processedFile, url: null }))
      setFieldErrors((prevErrors) => ({ ...prevErrors, file: false }))
    })
  }

  const handleRemoveWaste = (indexToRemove) => {
    setFormData((prevData) => ({
      ...prevData,
      wastes: prevData.wastes.filter((_, index) => index !== indexToRemove),
    }))
  }

  const handleDownload = () => {
    if (formData.url) {
      window.open(formData.url, "_blank")
    }
  }

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <>
            <Typography variant="h6" gutterBottom>
              Informazioni generali
            </Typography>
            <Box sx={{ mb: 2 }}>
              <input
                accept="*/*"
                style={{ display: "none" }}
                id="raised-button-file"
                type="file"
                onChange={handleFileChange}
              />
              <label htmlFor="raised-button-file">
                <Button
                  variant="contained"
                  component="span"
                  sx={{
                    color: "black!important",
                    boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
                    backgroundColor: "white!important",
                    borderColor: fieldErrors.file ? "red" : "primary.main",
                    "&:hover": {
                      borderColor: fieldErrors.file ? "red" : "primary.dark",
                    },
                  }}
                >
                  {formData.file || formData.url ? "Cambia prima copia" : "Carica prima copia"}
                </Button>
              </label>
              {(formData.file || formData.url) && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  {formData.file ? formData.file.name : "File già caricato"}
                </Typography>
              )}
              {(id && formData.file && formData.url) || formData.url ? (
                <Button
                  startIcon={<DownloadIcon />}
                  variant="contained"
                  color="primary"
                  sx={{
                    marginBottom: "30px",
                    color: "white!important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                  onClick={handleDownload}
                >
                  Scarica
                </Button>
              ) : null}
              {fieldErrors.file && (
                <Typography color="error" variant="caption" sx={{ mt: 1, display: "block" }}>
                  File richiesto
                </Typography>
              )}
            </Box>
           <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
              <DatePicker
                label="Data *"
                value={formData.date ? dayjs(formData.date) : null}
                sx={{color: fieldErrors.date ? 'red' : 'inherit', borderColor: fieldErrors.date ? 'red' : 'inherit', mb: 2}}
                onChange={(newValue) => {
                  const formattedDate = newValue ? dayjs(newValue).format('YYYY-MM-DD') : null;
                  handleInputChange('date', formattedDate);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    name="date"
                    sx={{mb: 2}}
                    required
                    error={fieldErrors.date}
                    helperText={fieldErrors.date ? 'Date is required' : ''}
                  />
                )}
                inputFormat="DD-MM-YYYY"
              />
            </LocalizationProvider>
            <TextField
              fullWidth
              label="Nome fornitore"
              name="supplier"
              value={formData.supplier}
              onChange={(e) => handleInputChange("supplier", e.target.value)}
              required
              error={fieldErrors.supplier}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Codice CER"
              name="cer_code"
              value={formData.cer_code}
              onChange={(e) => handleInputChange("cer_code", e.target.value)}
              required
              error={fieldErrors.cer_code}
              sx={{ mb: 2 }}
            />
          </>
        )
      case 1:
        return (
          <>
            <Typography variant="h6" gutterBottom>
              Rifiuti
            </Typography>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAddWaste}
              sx={{ mb: 3, color: "white!important" }}
            >
              Aggiungi rifiuto
            </Button>

            {formData.wastes.map((waste, index) => (
              <Box
                key={index}
                sx={{ display: "flex", alignItems: "center", mb: 2, borderTop: "1px solid #ccc", pt: 2 }}
              >
                <Typography variant="h6" sx={{ mr: 2 }}>
                  Rifiuto {index + 1}:
                </Typography>
                <Box sx={{ width: "50%", display: "flex", alignItems: "center", flexDirection: "column", gap: 1 }}>
                  <TextField
                    fullWidth
                    label={`Nome materiale`}
                    value={waste.material}
                    onChange={(e) => handleWasteInputChange(index, "material", e.target.value)}
                    required
                    error={fieldErrors[`waste_${index}_material`]}
                    variant="outlined"
                  />
                  <TextField
                    fullWidth
                    label={`Quantità`}
                    value={waste.quantity}
                    type="number"
                    onChange={(e) => handleWasteInputChange(index, "quantity", e.target.value)}
                    required
                    error={fieldErrors[`waste_${index}_quantity`]}
                    variant="outlined"
                  />
                </Box>
                <IconButton
                  onClick={() => handleRemoveWaste(index)}
                  sx={{ ml: 1 }}
                  aria-label={`Rimuovi rifiuto ${index + 1}`}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            ))}
            {formData.wastes.length === 0 && (
              <Typography variant="body1" sx={{ mt: 2, color: "text.secondary" }}>
                Nessun rifiuto aggiunto. Clicca sul pulsante "Aggiungi rifiuto" per iniziare.
              </Typography>
            )}
          </>
        )
      default:
        return null
    }
  }

  return (
    <DashboardLayout>
      {authContext?.hasAuth("UPDATE_GARBAGEFIRSTCOPY") ? (
        <>
          <DashboardNavbar />
          {!loading ? (
            <Paper elevation={3} sx={{ p: 3, maxWidth: 900, mx: "auto", mt: 4 }}>
              <center>
                <Typography variant="h5" gutterBottom>
                  Registrazione rifiuti
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => navigate("/garbage-first-copy-managment/")}
                  sx={{
                    mb: 3,
                    color: "white!important",
                  }}
                >
                  TORNA ALLA TABELLA
                </Button>
              </center>
              <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
                <Step>
                  <StepLabel>Informazioni generali</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Rifiuti</StepLabel>
                </Step>
              </Stepper>
              <Box component="form" noValidate autoComplete="off">
                {renderStepContent(activeStep)}
                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                  <Button onClick={handleBack} disabled={activeStep === 0} sx={{ color: "black!important", boxShadow: "0px 7px 14px rgba(0, 0, 0, 0.3)!important" }}>
                    Indietro
                  </Button>
                  {activeStep === 1 ? (
                    <Button variant="contained" onClick={handleSubmit} sx={{ color: "white!important" }}>
                      Salva
                    </Button>
                  ) : (
                    <Button variant="contained" onClick={handleNext} sx={{ color: "white!important" }}>
                      Avanti
                    </Button>
                  )}
                </Box>
              </Box>
            </Paper>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress size={120} sx={{ color: "#2b84ea" }} />
            </Box>
          )}
        </>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Typography variant="h6">Non hai il permesso di modificare questa registrazione</Typography>
        </Box>
      )}
    </DashboardLayout>
  )
}

export default GarbageFirstCopyAdd
